import { SBModel } from '@supplement-bacon/react-toolkit/models'
import { Entity } from '@utils/Entities'
import { CreateAdminInviteData } from './AdminInvite'

interface Admin extends SBModel {
  firstName: string
  lastName: string
  email: string
  phone: string
  locale: string
  emailVerifiedAt: string

  // Relations not in store
  roles: number[]
  permissions: string[]
  extraModels?: AdminExtraModel[]
}

interface CreateAdminData {
  first_name: string
  last_name: string
  email: string
  phone: string
  password: string
}

interface AdminExtraModel extends SBModel {
  entity: Entity
  model: { id: number; schema: Entity }
}

type UpdateAdminData = { id: number } & CreateAdminInviteData['roles']

const initials = (admin: Admin) =>
  admin.firstName.slice(0, 1) + admin.lastName.slice(0, 1)

export { initials }
export type { Admin, AdminExtraModel, CreateAdminData, UpdateAdminData }
